import { render, staticRenderFns } from "./RelatorioSaidaPaciente.vue?vue&type=template&id=39faeb9a"
import script from "./RelatorioSaidaPaciente.vue?vue&type=script&lang=js"
export * from "./RelatorioSaidaPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports